import React from 'react';

interface SkipLinkProps {
  targetId?: string;
  children?: React.ReactNode;
}

const SkipLink: React.FC<SkipLinkProps> = ({
  targetId = 'main-content',
  children = 'Skip to main content',
}) => (
  <a
    href={`#${targetId}`}
    className="
        sr-only focus:not-sr-only
        focus:absolute focus:top-2 focus:left-2 focus:z-[9999]
        focus:px-4 focus:py-2
        focus:bg-au-primary focus:text-white
        focus:rounded-au-base focus:outline-none
        focus:ring-2 focus:ring-au-primary focus:ring-offset-2
        font-medium text-sm
      "
  >
    {children}
  </a>
);

export default SkipLink;
